export class SofortPaymentModel {
    public invoiceId: number;
    public invoiceCode: string;
}
